import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addGradeData,
  deleteGradeData,
  fetchGradesList,
  updateGradeData,
} from "../../apis/grades";

export const fetchGrades = createAsyncThunk(
  "grades/fetchGrades",
  async (_, { rejectWithValue }) => {
    try {
      const result = await fetchGradesList();
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any;
      return !state.grades.isDataFetched;
    },
  }
);

export const addGrade = createAsyncThunk(
  "grades/addGrade",
  async ({ data }: { data: { [key: string]: any } }, { rejectWithValue }) => {
    try {
      const result = await addGradeData(data);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateGrade = createAsyncThunk(
  "grades/updateGrade",
  async (
    { grade_id, data }: { grade_id: string; data: { [key: string]: any } },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateGradeData(grade_id, data);
      return result;
    } catch (error: any) {
      const msg = error?.response?.data?.message || error?.message || "Unknown error";
      return rejectWithValue(msg);
    }
  }
);

export const deleteGrade = createAsyncThunk(
  "grades/deleteGrade",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const result = await deleteGradeData(id);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
